import React, { VFC, useState, useCallback } from 'react';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { useNotificationsPayrollList, useNotificationsLoadingState, useNotificationsErrorState } from '../../contexts';
import { AuthorizationsPayrollTable } from './AuthorizationsPayrollTable';

const AuthorizationsPayrollTableWrapper: VFC<{ classes: GenericObject }> = ({ classes }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const payrollList = useNotificationsPayrollList();
  const isLoadingPayrollList = useNotificationsLoadingState('isLoadingPendingAuthorizations');
  const hasPayrollListError = useNotificationsErrorState('pendingAuthorizationsListError');

  const onPageChange = useCallback((event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  }, []);

  return (
    <AuthorizationsPayrollTable
      payrolls={payrollList}
      payrollListError={hasPayrollListError}
      isLoading={isLoadingPayrollList}
      totalPages={10}
      currentPage={currentPage}
      onPageChange={onPageChange}
      classes={classes}
    />
  );
};

export { AuthorizationsPayrollTableWrapper };
